import { render } from "./LoadingModal.vue?vue&type=template&id=4b2f3fcc&ts=true"
import script from "./LoadingModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoadingModal.vue?vue&type=script&setup=true&lang=ts"

import "./LoadingModal.vue?vue&type=style&index=0&id=4b2f3fcc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/LoadingModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4b2f3fcc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b2f3fcc', __exports__)) {
    api.reload('4b2f3fcc', __exports__)
  }
  
  module.hot.accept("./LoadingModal.vue?vue&type=template&id=4b2f3fcc&ts=true", () => {
    api.rerender('4b2f3fcc', render)
  })

}


export default __exports__